import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface DeleteConfirmationModalProps {
    show: boolean;
    onClose: () => void;
    onDelete: () => void;
  }
  
  const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ show, onClose, onDelete }) => {
    return (
      <Modal show={show} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Potwierdź usunięcie.</Modal.Title>
        </Modal.Header>
        <Modal.Body>Czy na pewno chcesz usunąć?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Nie
          </Button>
          <Button variant="danger" onClick={onDelete}>
            Tak
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };
  
  export default DeleteConfirmationModal;